import { useMutation } from '@apollo/client'
import { parse } from 'date-fns'

import { ProfileInfoFormValues } from '../../../components/profile-info-form'
import {
    CreateUserProfile,
    CreateUserProfileVariables,
    UpdateUserProfile,
    UpdateUserProfileVariables,
} from '../../../graphql/masa-types'
import {
    CREATE_USER_PROFILE_MUTATION,
    IMPACT_USER_PRODUCT_INTEREST_MUTATION,
    UPDATE_USER_PROFILE_MUTATION,
} from './queries'

export function useProfileQueries(profile: any, user: any) {
    const [createUserProfile] = useMutation<
        CreateUserProfile,
        CreateUserProfileVariables
    >(CREATE_USER_PROFILE_MUTATION)

    const [updateUserProfile] = useMutation<
        UpdateUserProfile,
        UpdateUserProfileVariables
    >(UPDATE_USER_PROFILE_MUTATION)

    const [updateUserProductInterest] = useMutation(
        IMPACT_USER_PRODUCT_INTEREST_MUTATION,
    )

    async function create(data: ProfileInfoFormValues) {
        await updateUserProductInterest({
            variables: {
                input: {
                    userInterests: data.productInterests,
                },
            },
        })
        return await createUserProfile({
            variables: {
                input: {
                    id: user.attributes.sub,
                    email: user.attributes.email,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phone: user.attributes.phone_number,
                    dateOfBirth: parse(
                        data.dateOfBirth,
                        'MM/dd/yyyy',
                        new Date(),
                    ),
                    countryId: data.country,
                    availableRoles: data?.availableRoles?.length
                        ? data.availableRoles
                        : ['INDIVIDUAL'],
                    activeRole: data?.activeRole ?? 'INDIVIDUAL',
                    lastLoginDate: new Date(),
                },
            },
        })
    }

    async function update(data: ProfileInfoFormValues) {
        await updateUserProductInterest({
            variables: {
                input: {
                    userInterests: data.productInterests,
                },
            },
        })
        await updateUserProfile({
            variables: {
                input: {
                    // id: profile.id,
                    email: profile.email,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phone: profile.phone,
                    notifyEmail: data?.notifyEmail,
                    notifyPhone: data?.notifyPhone,
                    dateOfBirth: parse(
                        data.dateOfBirth,
                        'MM/dd/yyyy',
                        new Date(),
                    ),
                    countryId: data.country,
                    availableRoles: data?.availableRoles?.length
                        ? data.availableRoles
                        : ['INDIVIDUAL'],
                    activeRole: data?.activeRole ?? 'INDIVIDUAL',
                },
            },
        })
    }

    return {
        update,
        create,
    }
}
